export const SLICE_TYPES = ['sagittal', 'coronal', 'axial'] as const;
export type SliceType = typeof SLICE_TYPES[number];